import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import Flex from './Flex.js';
import { getTileClasses } from './shared/utils.js';
import { tileGroupProps } from './shared/propTypes.js';

function TileGroup(_a) {
  var {
      className,
      count = 3,
      dateTransform,
      dateType,
      end,
      hover,
      offset,
      start,
      step = 1,
      tile: Tile,
      value,
      valueType
    } = _a,
    tileProps = __rest(_a, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);
  const tiles = [];
  for (let point = start; point <= end; point += step) {
    const date = dateTransform(point);
    tiles.push(React.createElement(Tile, Object.assign({
      key: date.getTime(),
      classes: getTileClasses({
        value,
        valueType,
        date,
        dateType,
        hover
      }),
      date: date,
      point: point,
      value: value
    }, tileProps)));
  }
  return React.createElement(Flex, {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}
TileGroup.propTypes = Object.assign(Object.assign({}, tileGroupProps), {
  activeStartDate: PropTypes.instanceOf(Date),
  count: PropTypes.number,
  dateTransform: PropTypes.func.isRequired,
  dateType: PropTypes.string,
  offset: PropTypes.number,
  step: PropTypes.number,
  tile: PropTypes.func.isRequired
});

export { TileGroup as default };
